import { useState, useEffect, useRef } from 'react';

const useTimer = (shouldRun) => {
    const [elapsedTime, setElapsedTime] = useState(0);
    const startTimeRef = useRef(null);
    const accumulatedTimeRef = useRef(0);

    useEffect(() => {
        let timer;
        if (shouldRun) {
            if (!startTimeRef.current) {
                startTimeRef.current = Date.now();
            }
            timer = setInterval(() => {
                setElapsedTime(accumulatedTimeRef.current + (Date.now() - startTimeRef.current));
            }, 1); // Update every millisecond
        } else {
            if (startTimeRef.current) {
                accumulatedTimeRef.current += Date.now() - startTimeRef.current;
                startTimeRef.current = null;
            }
            setElapsedTime(accumulatedTimeRef.current);
        }

        return () => clearInterval(timer);
    }, [shouldRun]);

    const resetTimer = () => {
        setElapsedTime(0);
        accumulatedTimeRef.current = 0;
        startTimeRef.current = null;
    };

    return [elapsedTime / 1000, resetTimer]; // Convert to seconds and return reset function
};

export default useTimer;